<script>
import NotificationSnackbar from "@/components/NotificationSnackbar.vue";
import ApiService, { BASE_URL } from "@/api/ApiService";

const PAGE_ITEMS = [{ text: "Главная", value: "home" }];
const API = "api/vk-reviews";

function emptySettings() {
  return {
    topicUrl: "",
    importFrom: "",
    liveMode: false,
    tokenPresent: false,
  };
}

export default {
  name: "AdminVkReviewsView",
  components: { NotificationSnackbar },
  data() {
    return {
      selectedBrand: "neurobica",
      tab: 0,
      brands: [
        { value: "upmind", label: "UpMIND+" },
        { value: "neurobica", label: "Neurobica" },
      ],
      settings: emptySettings(),
      reviews: [],
      tokenDraft: "",
      showToken: false,
      loading: false,
      saving: false,
      syncing: false,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
      editDialog: false,
      editItem: {},
    };
  },
  computed: {
    publishedCount() {
      return this.reviews.filter((item) => item.showOnSite).length;
    },
    headers() {
      return [
        { text: "", value: "order", width: 88, sortable: false },
        { text: "На сайт", value: "showOnSite", width: 110, sortable: false },
        { text: "Автор", value: "author", width: "16%" },
        { text: "Дата VK", value: "date", width: 140 },
        { text: "Отзыв", value: "text" },
        { text: "Видео", value: "hasVideo", width: 180, sortable: false },
        { text: "Страница", value: "page", width: 120 },
        { text: "VK", value: "vkUrl", width: 90, sortable: false },
        { text: "Действия", value: "actions", width: 90, sortable: false },
      ];
    },
  },
  watch: {
    selectedBrand() {
      this.tokenDraft = "";
      this.showToken = false;
      this.loadBrand();
    },
  },
  mounted() {
    this.loadBrand();
  },
  methods: {
    unwrap(res, fallback) {
      if (!res || res.success === false) {
        const payload = res && res.data;
        const msg =
          (payload && (payload.error || payload.message)) ||
          (res && res.message) ||
          fallback;
        throw new Error(typeof msg === "string" ? msg : fallback);
      }
      return res.data;
    },
    notify(message, color = "success") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    authorOf(item) {
      return [item.firstName, item.lastName].filter(Boolean).join(" ") || "—";
    },
    pageLabel(value) {
      return PAGE_ITEMS.find((item) => item.value === value)?.text || value;
    },
    formatDate(value) {
      if (!value) return "—";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    mediaUrl(url) {
      if (!url) return "";
      if (/^https?:\/\//i.test(url)) return url;
      const base = String(BASE_URL || "").replace(/\/$/, "");
      return `${base}${url.startsWith("/") ? url : `/${url}`}`;
    },
    videoChip(item) {
      if (!item.hasVideo) return { text: "Нет", color: "grey" };
      if (item.videoStatus === "ready") {
        return { text: "На сервере", color: "success" };
      }
      if (item.videoStatus === "queued") {
        return { text: "Заливается", color: "warning" };
      }
      if (item.videoStatus === "error") {
        return { text: "Ошибка", color: "error" };
      }
      return { text: "Есть в VK", color: "primary" };
    },
    replaceReview(updated) {
      const index = this.reviews.findIndex((row) => row.id === updated.id);
      if (index === -1) {
        this.reviews.push(updated);
        return;
      }
      this.$set(this.reviews, index, updated);
    },
    async loadBrand() {
      this.loading = true;
      try {
        const data = this.unwrap(
          await ApiService.get(API, { brand: this.selectedBrand }),
          "Не удалось загрузить отзывы"
        );
        this.settings = { ...emptySettings(), ...(data.settings || {}) };
        this.reviews = Array.isArray(data.reviews) ? data.reviews : [];
      } catch (error) {
        this.settings = emptySettings();
        this.reviews = [];
        this.notify(error.message, "error");
      } finally {
        this.loading = false;
      }
    },
    async saveSettings() {
      this.saving = true;
      try {
        const payload = {
          brand: this.selectedBrand,
          topicUrl: this.settings.topicUrl,
          importFrom: this.settings.importFrom,
          liveMode: this.settings.liveMode,
        };
        if (this.tokenDraft.trim()) {
          payload.serviceToken = this.tokenDraft.trim();
        }
        const data = this.unwrap(
          await ApiService.put(`${API}/settings`, payload),
          "Не удалось сохранить настройки"
        );
        this.settings = { ...emptySettings(), ...data };
        this.tokenDraft = "";
        this.notify("Настройки сохранены на сервере");
      } catch (error) {
        this.notify(error.message, "error");
      } finally {
        this.saving = false;
      }
    },
    async syncFromVk() {
      this.syncing = true;
      try {
        const data = this.unwrap(
          await ApiService.post(`${API}/sync`, { brand: this.selectedBrand }),
          "Не удалось подгрузить VK"
        );
        this.reviews = Array.isArray(data.reviews) ? data.reviews : [];
        const errors = Array.isArray(data.videoErrors) ? data.videoErrors : [];
        if (errors.length) {
          const first =
            errors[0] && errors[0].error ? `: ${errors[0].error}` : "";
          this.notify(
            `Подгружено, но ${errors.length} видео не залились${first}`,
            "warning"
          );
        } else {
          this.notify(
            `Подгружено: новых ${data.created || 0}, обновлено ${
              data.updated || 0
            }. Видео залиты на наш сервер.`
          );
        }
      } catch (error) {
        this.notify(error.message, "error");
      } finally {
        this.syncing = false;
      }
    },
    async toggleLiveMode() {
      await this.saveSettings();
    },
    async togglePublish(item, value) {
      this.saving = true;
      try {
        const updated = this.unwrap(
          await ApiService.patch(`${API}/${item.id}`, {
            showOnSite: Boolean(value),
          }),
          "Не удалось выложить отзыв"
        );
        this.replaceReview(updated);
        if (updated.showOnSite && updated.hasVideo) {
          this.notify("Отзыв на сайте, видео с нашего сервера");
        }
      } catch (error) {
        this.notify(error.message, "error");
        await this.loadBrand();
      } finally {
        this.saving = false;
      }
    },
    async ingestVideo(item) {
      this.saving = true;
      try {
        const updated = this.unwrap(
          await ApiService.post(`${API}/${item.id}/ingest-video`, {}),
          "Не удалось залить видео"
        );
        this.replaceReview(updated);
        this.notify("Видео залито на наш сервер");
      } catch (error) {
        this.notify(error.message, "error");
        await this.loadBrand();
      } finally {
        this.saving = false;
      }
    },
    async moveItem(item, direction) {
      const index = this.reviews.findIndex((row) => row.id === item.id);
      const next = index + direction;
      if (index === -1 || next < 0 || next >= this.reviews.length) return;
      const copy = [...this.reviews];
      const [row] = copy.splice(index, 1);
      copy.splice(next, 0, row);
      this.reviews = copy;
      try {
        const data = this.unwrap(
          await ApiService.post(`${API}/reorder`, {
            brand: this.selectedBrand,
            ids: this.reviews.map((review) => review.id),
          }),
          "Не удалось сохранить порядок"
        );
        if (Array.isArray(data.reviews)) this.reviews = data.reviews;
      } catch (error) {
        this.notify(error.message, "error");
        await this.loadBrand();
      }
    },
    async resetOrderByDate() {
      try {
        const data = this.unwrap(
          await ApiService.post(`${API}/reset-order`, {
            brand: this.selectedBrand,
          }),
          "Не удалось сбросить порядок"
        );
        this.reviews = Array.isArray(data.reviews) ? data.reviews : [];
        this.notify("Порядок сброшен к дате публикации VK");
      } catch (error) {
        this.notify(error.message, "error");
      }
    },
    openEdit(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    async saveEdit() {
      this.saving = true;
      try {
        const updated = this.unwrap(
          await ApiService.patch(`${API}/${this.editItem.id}`, {
            firstName: this.editItem.firstName,
            lastName: this.editItem.lastName,
            text: this.editItem.text,
            page: this.editItem.page,
            showOnSite: this.editItem.showOnSite,
          }),
          "Не удалось сохранить отзыв"
        );
        this.replaceReview(updated);
        this.editDialog = false;
        this.notify("Отзыв сохранён");
      } catch (error) {
        this.notify(error.message, "error");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <notification-snackbar
      :value.sync="snackbar"
      :message="snackbarMessage"
      :color="snackbarColor"
    />

    <div class="text-h6 text-sm-h4 my-4">Отзывы из VK</div>

    <v-alert dense text type="info" class="mb-4">
      Ключ VK хранится только на сервере. При «Подгрузить из VK» видео сразу
      скачиваются к нам: на сайт уходит наша ссылка, не плеер ВКонтакте.
    </v-alert>

    <v-chip-group
      v-model="selectedBrand"
      mandatory
      active-class="primary accent-4 white--text"
      class="mb-4"
    >
      <v-chip
        v-for="brand in brands"
        :key="brand.value"
        color="white"
        :value="brand.value"
      >
        {{ brand.label }}
      </v-chip>
    </v-chip-group>

    <v-tabs v-model="tab" class="mb-4">
      <v-tab>Отзывы</v-tab>
      <v-tab>Настройки</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div
          class="d-flex flex-wrap align-center justify-space-between mb-4"
          style="gap: 12px"
        >
          <div class="grey--text text--darken-1">
            На сайт: {{ publishedCount }} из {{ reviews.length }}. Страница пока
            только «Главная».
          </div>
          <div class="d-flex flex-wrap" style="gap: 8px">
            <v-btn
              outlined
              color="primary"
              :disabled="!reviews.length || loading"
              @click="resetOrderByDate"
            >
              Сбросить к датам
            </v-btn>
            <v-btn
              color="#d86568"
              class="white--text"
              :loading="syncing"
              :disabled="loading"
              @click="syncFromVk"
            >
              <v-icon left>mdi-cloud-download</v-icon>
              Подгрузить из VK
            </v-btn>
          </div>
        </div>

        <v-card>
          <v-progress-linear v-if="loading || saving" indeterminate />
          <v-data-table
            :headers="headers"
            :items="reviews"
            :items-per-page="-1"
            hide-default-footer
            disable-pagination
            dense
            class="table"
            no-data-text="Пока нет отзывов. Сохраните ключ и нажмите «Подгрузить из VK»."
          >
            <template v-slot:[`item.order`]="{ item, index }">
              <div class="d-inline-flex">
                <v-btn
                  icon
                  small
                  :disabled="index === 0"
                  @click="moveItem(item, -1)"
                >
                  <v-icon small>mdi-arrow-up</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  :disabled="index === reviews.length - 1"
                  @click="moveItem(item, 1)"
                >
                  <v-icon small>mdi-arrow-down</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.showOnSite`]="{ item }">
              <v-switch
                :input-value="item.showOnSite"
                dense
                hide-details
                class="ma-0 pa-0"
                :disabled="saving"
                @click.stop
                @change="togglePublish(item, $event)"
              />
            </template>
            <template v-slot:[`item.author`]="{ item }">
              {{ authorOf(item) }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ formatDate(item.date) }}
            </template>
            <template v-slot:[`item.text`]="{ item }">
              <span
                class="d-inline-block text-truncate"
                style="max-width: 360px"
              >
                {{ item.text || "—" }}
              </span>
            </template>
            <template v-slot:[`item.hasVideo`]="{ item }">
              <div class="d-flex align-center" style="gap: 8px">
                <img
                  v-if="item.posterUrl"
                  :src="mediaUrl(item.posterUrl)"
                  alt=""
                  class="vk-poster"
                />
                <v-chip x-small :color="videoChip(item).color" dark>
                  {{ videoChip(item).text }}
                </v-chip>
                <v-btn
                  v-if="item.hasVideo && item.videoStatus !== 'ready'"
                  icon
                  x-small
                  :title="item.videoError || 'Залить видео на наш сервер'"
                  :disabled="saving"
                  @click.stop="ingestVideo(item)"
                >
                  <v-icon x-small>mdi-upload</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.page`]="{ item }">
              {{ pageLabel(item.page) }}
            </template>
            <template v-slot:[`item.vkUrl`]="{ item }">
              <a
                v-if="item.vkUrl"
                :href="item.vkUrl"
                target="_blank"
                rel="noopener noreferrer"
                @click.stop
              >
                Открыть
              </a>
              <span v-else>—</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon small color="primary" @click="openEdit(item)">
                <v-icon small>mdi-playlist-edit</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card class="pa-4 pa-sm-6">
          <div class="text-h6 mb-4">
            Источник для
            {{ selectedBrand === "neurobica" ? "Neurobica" : "UpMIND+" }}
          </div>
          <v-text-field
            v-model="tokenDraft"
            :type="showToken ? 'text' : 'password'"
            :append-icon="showToken ? 'mdi-eye' : 'mdi-eye-off'"
            label="Сервисный ключ Mini App"
            :hint="
              settings.tokenPresent
                ? 'Ключ уже сохранён на сервере. Вставьте новый, чтобы заменить.'
                : 'Не попадёт на сайт и не уйдёт в git.'
            "
            persistent-hint
            outlined
            dense
            class="mb-6"
            autocomplete="off"
            @click:append="showToken = !showToken"
          />
          <v-text-field
            v-model="settings.topicUrl"
            label="Ссылка на обсуждение VK"
            placeholder="https://vk.ru/topic-123_456"
            hint="Откуда забирать комментарии."
            persistent-hint
            outlined
            dense
            class="mb-6"
          />
          <v-text-field
            v-model="settings.importFrom"
            label="Подгружать отзывы с даты"
            type="date"
            hint="Комментарии старше этой даты не попадут в таблицу."
            persistent-hint
            outlined
            dense
            class="mb-6"
          />
          <v-switch
            v-model="settings.liveMode"
            label="Боевой режим для главной"
            hint="На главной Neurobica останутся только отмеченные VK-отзывы. Другие страницы не трогаем."
            persistent-hint
            class="mb-8"
            @change="toggleLiveMode"
          />
          <v-btn
            color="#d86568"
            class="white--text"
            :loading="saving"
            @click="saveSettings"
          >
            Сохранить настройки
          </v-btn>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="editDialog" max-width="720">
      <v-card>
        <v-card-title>Редактировать отзыв</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editItem.firstName"
            label="Имя"
            outlined
            dense
            class="mb-2"
          />
          <v-text-field
            v-model="editItem.lastName"
            label="Фамилия"
            outlined
            dense
            class="mb-2"
          />
          <v-textarea
            v-model="editItem.text"
            label="Текст"
            outlined
            rows="6"
            class="mb-2"
          />
          <v-select
            v-model="editItem.page"
            :items="[{ text: 'Главная', value: 'home' }]"
            label="Страница"
            outlined
            dense
            class="mb-2"
          />
          <v-switch v-model="editItem.showOnSite" label="Показывать на сайте" />
          <div v-if="editItem.vkUrl" class="mt-2">
            <a :href="editItem.vkUrl" target="_blank" rel="noopener noreferrer">
              Оригинал в ВКонтакте
            </a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editDialog = false">Отмена</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEdit">
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.vk-poster {
  width: 28px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  background: #1c1c1e;
  flex-shrink: 0;
}
</style>
